<app-menu>
  <div class="tpl-shell" [class.has-selection]="selectedCount > 0">
    <header class="tpl-toolbar print-hidden">
      <div class="tpl-title-stack">
        <button type="button" class="tpl-icon-button" (click)="backToSource()" [title]="backTitle">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
        <div class="min-w-0">
          <div class="tpl-eyebrow">{{ pageEyebrow }}</div>
          <h1>{{ pageTitle }}</h1>
          <p>{{ batchInfo }}</p>
        </div>
      </div>

      <div class="tpl-toolbar-controls">
        <label class="tpl-check">
          <input type="checkbox" [checked]="allSelected" (change)="toggleAll($any($event.target).checked)">
          <span>All</span>
        </label>

        <select class="tpl-select" [value]="brand" (change)="setBrand($any($event.target).value)">
          <option value="FBI">FBI</option>
          <option value="ULAAP">ULAAP</option>
        </select>

        <button type="button" class="tpl-button tpl-button--ghost" (click)="loadLabels()" [disabled]="loading">
          <i class="fa-solid fa-rotate" [class.fa-spin]="loading"></i>
          <span>{{ loading ? 'Loading' : 'Refresh' }}</span>
        </button>

        <button type="button" class="tpl-button tpl-button--primary" (click)="printSelected()" [disabled]="!labels.length">
          <i class="fa-solid fa-print"></i>
          <span>Print</span>
        </button>
      </div>
    </header>

    <div class="tpl-alert print-hidden" *ngIf="errorMessage">
      <i class="fa-solid fa-triangle-exclamation"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <div class="tpl-empty print-hidden" *ngIf="!loading && !errorMessage && !labels.length">
      <i class="fa-solid fa-tags"></i>
      <span>{{ emptyMessage }}</span>
    </div>

    <main class="labels-grid" *ngIf="labels.length">
      <article
        class="label-card"
        *ngFor="let label of labels; trackBy: trackByLabel"
        [class.selected]="isSelected(label.uuid)"
        [class.print-last]="isLastPrintable(label.uuid)"
        (click)="toggleLabel(label.uuid)"
      >
        <div class="label-preview">
          <div class="label-header">
            <div class="min-w-0">
              <div class="label-customer">{{ label.customer }}</div>
              <div class="label-mid">{{ label.name }}</div>
              <div class="label-meta">{{ label.store }}</div>
            </div>
            <img class="brand-logo" [src]="currentBrand.logoSrc" [alt]="currentBrand.displayName">
          </div>

          <div class="label-note">
            <div class="detail-line" *ngIf="label.model"><strong>Model:</strong> {{ label.model }}</div>
            <div class="barcode-container" *ngIf="label.model"><svg #modelBarcode class="barcode-model" [attr.data-val]="label.model"></svg></div>

            <div class="detail-line" *ngIf="label.serial"><strong>Serial:</strong> {{ label.serial }}</div>
            <div class="barcode-container" *ngIf="label.serial"><svg #serialBarcode class="barcode-serial" [attr.data-val]="label.serial"></svg></div>

            <div class="detail-line detail-line--desc" *ngIf="label.desc"><strong>Desc:</strong> {{ label.desc }}</div>
            <div class="detail-line" *ngIf="label.dims.l || label.dims.w || label.dims.h"><strong>Dims:</strong> {{ label.dims.l || 0 }} x {{ label.dims.w || 0 }} x {{ label.dims.h || 0 }}</div>
            <div class="detail-line" *ngIf="label.weight"><strong>Weight:</strong> {{ label.weight }}</div>
            <div class="detail-line" *ngIf="label.stackable !== null && label.stackable !== undefined"><strong>Stackable:</strong> {{ stackableText(label.stackable) }}</div>

            <ng-container *ngIf="label.note">
              <div class="note-separator"></div>
              <div class="detail-note">{{ label.note }}</div>
            </ng-container>
          </div>

          <div class="label-details">
            <span><strong>Date:</strong> {{ label.intakeDate }}</span>
            <span *ngIf="label.count" class="label-qty"><strong>Qty:</strong> {{ label.count }}</span>
          </div>

          <div class="label-footer">
            <div class="uuidline"><strong>UUID:</strong><br>{{ label.uuid }}</div>
            <div class="qr" #qrTarget [attr.data-uuid]="label.uuid"></div>
          </div>
        </div>
      </article>
    </main>
  </div>
</app-menu>
